<template>
  <div>
    <div
      :itemscope="faqSchema ? true : null" :itemprop="faqSchema ? 'mainEntity' : null" :itemtype="faqSchema ? 'https://schema.org/Question' : null"
      v-for="(item, index) in items"
      :key="'item_' + index"
      class="mt-6"
    >
      <div class="not-prose flex items-center justify-start pb-4 gap-4 md:gap-6">
        <div v-if="numbers" class="w-auto">
            <div class="flex h-8 w-8 leading-none text-xl rounded-sm p-4 bg-primary items-center justify-center font-bold text-white" tabindex="0">
            {{ index + 1 }}.
            </div>
        </div>
        <div class="flex-1" tabindex="0">
            <div @click="setActive('item_' + index)" class="inline-flex text-xl cursor-pointer antialiased pr-4" tabindex="0"
            :class="{
              'text-primary': active != 'item_' + index,
              'text-secondary': active == 'item_' + index
              }">
              <span v-if="headingLevel == ''" :itemprop="faqSchema ? 'name' : null" >{{ item.item }}</span>
              <h4 v-if="headingLevel == 'h4'" :itemprop="faqSchema ? 'name' : null" class="page-h4">{{ item.item }}</h4>
              <h3 v-if="headingLevel == 'h3'" :itemprop="faqSchema ? 'name' : null" class="page-h3">{{ item.item }}</h3>
              <h2 v-if="headingLevel == 'h2'" :itemprop="faqSchema ? 'name' : null" class="page-h2">{{ item.item }}</h2>

              <span
                class="text-primary hover:text-primary/100 inline-flex h-5 md:h-6 w-5 md:w-6 items-center self-center justify-center rounded-full ml-2 leading-none my-auto"
              >
                <svg-vue
                  icon="nav-arrow"
                  class="fill-current h-3 w-4 transition-transform duration-700"
                  :class="{ '-rotate-90': active != 'item_' + index }"
                ></svg-vue>
              </span>
            </div>
        </div>
      </div>
      <div
        class="w-full bg-gray-100 dark:bg-gray-800 rounded transition-all duration-500 overflow-hidden" tabindex="0"
        :itemscope="faqSchema ? true : null" :itemprop="faqSchema ? 'acceptedAnswer' : null" :itemtype="faqSchema ? 'https://schema.org/Answer' : null"
        :class="{
          'h-0 opacity-0': active != 'item_' + index,
          'h-auto opacity-100 mb-2 md:mb-6 lg:mb-10': active == 'item_' + index
        }"
      >
        <div
          :itemprop="faqSchema ? 'text' : null"
          class="prose md:prose-md dark:prose-invert w-full max-w-5xl p-6 md:p-8"
          v-html="item.content" />
        </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    faqSchema: {
      type: Boolean,
      default: false
    },
    numbers: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },
    headingLevel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      active: ''
    }
  },
  mounted () {
    if(this.open) {
      this.active = 'item_0'
    }
  },
  methods: {
    setActive (name) {
      if(this.active == name){
        this.active = ''
      }else{
        this.active = name
      }

    }
  }
}
</script>
